import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MobileVehiclesService } from 'src/app/services/mobile/mobile-vehicles.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';

@Component({
  selector: 'app-mobile-vehicle-details',
  templateUrl: './mobile-vehicle-details.component.html',
  styleUrls: ['./mobile-vehicle-details.component.css']
})
export class MobileVehicleDetailsComponent implements OnInit{
  public isLoading: boolean = false;
  public isUploading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public vehicle_id: string = '';
  public chassis_no: string | null = null;
  public userPermissions: string[] = [];
  vehicle: any;
  photos: any[] = [];
  public vehicle_status:string='';
  public vehicle_location_status:string='';

  constructor(
    private activatedRoute:ActivatedRoute,
    private mobileVehiclesService: MobileVehiclesService,
    private authService: AuthService,
    private toastr: ToastrService,
    private location: Location,
    private router: Router,
  ){

  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.isLoading=true;
      this.getVehicleData(this.vehicle_id);

      //Get user permissions
      this.userPermissions=this.authService.getPermissions();
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

  /**
   * Get vehicle details
   * @param vehicle_id
   */
  getVehicleData(vehicle_id: string): void{
    this.mobileVehiclesService.getVehicle(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load vehicle details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Unable to load vehicle details. Please refresh the page and try again.";
            this.toastr.error(this.errorMessage, 'Error!');
          }else{
            //Set chassis number
            this.chassis_no = this.vehicle.data.chassis_no;

            //Determine vehicle status
            if(this.vehicle.data.status==0){
              this.vehicle_status="En route";
            }else if(this.vehicle.data.status==1){
              this.vehicle_status="At CFS";
            }else if(this.vehicle.data.status==2){
              this.vehicle_status="In Stock";
            }else if(this.vehicle.data.status==3){
              this.vehicle_status="Being Transferred";
            }else if(this.vehicle.data.status==4){
              this.vehicle_status="On Road Test";
            }else if(this.vehicle.data.status==6){
              this.vehicle_status="In Japan Stock";
            }

            this.isLoading=false;
            this.getVehiclePhotos(vehicle_id); //Load photos
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  /**
   * Get vehicle photos
   * @param vehicle_id
   */
  getVehiclePhotos(vehicle_id: string|null):void
  {
    this.isLoading=true;

    this.mobileVehiclesService.fetchVehiclePhotos(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading=false;
          this.photos = response.data;
        }else if(response.status==='no_data'){
          this.isLoading=false;
          this.toastr.warning(response.message, 'Warning!');
        }else{
          this.isLoading=false;
          this.errorMessage="Unable to load supplier photos. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  /**
   * Check vehicle status
   */
  checkVehicleStatus(vehicle_id: string){
    this.isLoading=true;

    this.mobileVehiclesService.getVehicleStatus(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading=false;
          this.vehicle_location_status = response.data.toString();

          if(this.vehicle_location_status=='AT_CFS'){

            this.router.navigate(['mobile/receive-vehicle-from-port',this.vehicle_id]);

          }else if(this.vehicle_location_status=='IN_STOCK' || this.vehicle_location_status=='PENDING_TRANSIT'){

            this.router.navigate(['mobile/transfer-release-vehicle',this.vehicle_id]);

          }else if(this.vehicle_location_status=='BEING_TRANSFERRED' || this.vehicle_location_status=='ON_ROAD_TEST' || this.vehicle_location_status=='IN_SERVICE'){

            this.router.navigate(['mobile/transfer-receive-vehicle',this.vehicle_id]);

          }else if(this.vehicle_location_status=='SOLD'){

            this.router.navigate(['mobile/deliver-sold-vehicle',this.vehicle_id]);

          }else if(this.vehicle_location_status=='ENROUTE'){

            this.toastr.error('The vehicle is en route thus it cannot be received or transferred!', 'Error!');

          }else if(this.vehicle_location_status=='NOT_SHIPPED'){

            this.toastr.error('The vehicle is in Japan stock thus it cannot be received or transferred!', 'Error!');

          }else {

            this.toastr.error('Unknown vehicle status. Please consult your system administrator!', 'Error!');

          }
        }else if(response.status==='no_data'){
          this.isLoading=false;
          this.toastr.warning(response.message, 'Warning!');
        }else{
          this.isLoading=false;
          this.errorMessage="Unable to determine vehicle status. Please try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  updateSpareParts(vehicle_id: string){
    this.router.navigate(['mobile/update-vehicle-spare-parts',vehicle_id]);
  }

  deliverToCustomer(vehicle_id: string){
    this.router.navigate(['mobile/deliver-sold-vehicle',vehicle_id]);
  }

  goBack(): void {
    this.location.back();
  }
}
